"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isInAmpMode", {
    enumerable: true,
    get: function() {
        return isInAmpMode;
    }
});
function isInAmpMode(param) {
    let { ampFirst =false , hybrid =false , hasQuery =false  } = param === void 0 ? {} : param;
    return ampFirst || hybrid && hasQuery;
}

//# sourceMappingURL=amp-mode.js.map